import React from "react";
import { Modal } from "react-bootstrap";

const HelpModal = ({ show, onHide, title, tableData }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '300px', overflowY: 'auto' }}>
                <table className="table table-sm">
                    <tbody>
                    {tableData.map(([code, desc], idx) => (
                        <tr key={idx}><td>{code}</td><td>{desc}</td></tr>
                    ))}
                    </tbody>
                </table>
            </Modal.Body>
        </Modal>
    );
};

export default HelpModal;